import i18next from "i18next";
import * as basinsServices from "../../services/basinsServices";
import { useEffect, useState } from "react";
import Autocomplete from "../../components/Autocomplete";
import MultiSelect from "../../components/MultiSelect";
import useDebouncedFunction from "../../hooks/useDebouncedFunction";

interface BasinsSelectProps {
	value: any;
	showValue?: any;
	onChange?: any;
	error?: any;
	multiple?: boolean;
	renderValue?: (value: any) => JSX.Element;
	required?: boolean;
}

const BasinSelect = ({ multiple, value, showValue, renderValue, onChange, error, required }: BasinsSelectProps) => {
	const [basins, setBasins] = useState<any>([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (!showValue) {
			handleChangeSearch({ target: { value: "" } });
		}
	}, [showValue]);

	const handleChangeSearch = async (e: any) => {
		setLoading(true);
		const value = e?.target?.value ?? "";

		var basins = await basinsServices.search({ skip: 0, limit: 10, search: value });
		basins = basins.result.map((basin) => ({
			label: basin.name,
			value: basin,
			...basin,
		}));
		setBasins(basins);
		setLoading(false);
	};

	const debouncedSearch = useDebouncedFunction(handleChangeSearch);

	if (multiple)
		return (
			<MultiSelect
				options={basins.filter((g) => !value?.map((g) => g.id).includes(g.id))}
				placeholder={i18next.t("entity-search", { entity: i18next.t("Basin") })}
				datatestid={"search-basin-input"}
				label={i18next.t("basins")}
				value={value}
				onInputChange={(e) => {
					setLoading(true);
					debouncedSearch(e);
				}}
				renderValue={renderValue}
				showValue={showValue}
				onChange={onChange}
				error={error}
				loading={loading}
				required={required}
			/>
		);

	return (
		<Autocomplete
			error={error}
			className="mt-3"
			id="basin"
			onInputChange={(e) => {
				setLoading(true);
				debouncedSearch(e);
			}}
			options={basins}
			datatestid={"search-basin-input"}
			onChange={onChange}
			placeholder={i18next.t("entity-search", { entity: i18next.t("Basin") })}
			label={i18next.t("basin")}
			value={value}
			showValue={showValue}
			loading={loading}
			required={required}
		/>
	);
};

export default BasinSelect;
